import RequestType from './RequestType'
import ExportFile from './ExportFile'
export class RequestTypeFile {
    ID: number;
    FileID: number;
    ExportFile: ExportFile;
    RequestTypeID: number;
    RequestType: RequestType;

}

export default RequestTypeFile;